/* tslint:disable */
/* eslint-disable */
export enum NotificationType {
  Success = 0,
  Info = 1,
  Warn = 2,
  Error = 3
}
